module.exports = __webpack_public_path__ + "img/group.67f2c40b.svg";